import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {KompenzacijaDocument} from "./KompenzacijaDocument";
import {ZapisnikOIzvsenomPosluDocument} from "./ZapisnikOIzvsenomPosluDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, partner, sektor
// opciono: opis posla, lista priloga
export const zapisnikOIzvsenomPosluDocumentDocumentFields: IntercateKeysMap<ZapisnikOIzvsenomPosluDocument, EntityField<ZapisnikOIzvsenomPosluDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: (item: { clientId: any; }) => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<ZapisnikOIzvsenomPosluDocument>> = [
	zapisnikOIzvsenomPosluDocumentDocumentFields.indexingNumber,
	zapisnikOIzvsenomPosluDocumentDocumentFields.indexingDate,
	zapisnikOIzvsenomPosluDocumentDocumentFields.documentNumber,
	zapisnikOIzvsenomPosluDocumentDocumentFields.documentDate,
	zapisnikOIzvsenomPosluDocumentDocumentFields.assignedTo,
	zapisnikOIzvsenomPosluDocumentDocumentFields.clientId,
	zapisnikOIzvsenomPosluDocumentDocumentFields.sectorId,
	zapisnikOIzvsenomPosluDocumentDocumentFields.tags,
	zapisnikOIzvsenomPosluDocumentDocumentFields.description,
	zapisnikOIzvsenomPosluDocumentDocumentFields.parentId
]

export const zapisnikOIzvrsenomPosluDocumentFieldsDescriptor: EntityFieldsDescriptor<ZapisnikOIzvsenomPosluDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
